import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensGroupSummaries} from './citizens-group-summaries.model';

export const loadCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Load CitizensGroupSummariess',
  props<{ citizensGroupSummariess: CitizensGroupSummaries[] }>()
);

export const addCitizensGroupSummaries = createAction(
  '[CitizensGroupSummaries/API] Add CitizensGroupSummaries',
  props<{ citizensGroupSummaries: CitizensGroupSummaries }>()
);

export const upsertCitizensGroupSummaries = createAction(
  '[CitizensGroupSummaries/API] Upsert CitizensGroupSummaries',
  props<{ citizensGroupSummaries: CitizensGroupSummaries }>()
);

export const addCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Add CitizensGroupSummariess',
  props<{ citizensGroupSummariess: CitizensGroupSummaries[] }>()
);

export const upsertCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Upsert CitizensGroupSummariess',
  props<{ citizensGroupSummariess: CitizensGroupSummaries[] }>()
);

export const updateCitizensGroupSummaries = createAction(
  '[CitizensGroupSummaries/API] Update CitizensGroupSummaries',
  props<{ citizensGroupSummaries: Update<CitizensGroupSummaries> }>()
);

export const updateCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Update CitizensGroupSummariess',
  props<{ citizensGroupSummariess: Update<CitizensGroupSummaries>[] }>()
);

export const deleteCitizensGroupSummaries = createAction(
  '[CitizensGroupSummaries/API] Delete CitizensGroupSummaries',
  props<{ id: string }>()
);

export const deleteCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Delete CitizensGroupSummariess',
  props<{ ids: string[] }>()
);

export const clearCitizensGroupSummariess = createAction(
  '[CitizensGroupSummaries/API] Clear CitizensGroupSummariess'
);


//custom

export const citizenGetGroupSummaries = createAction(
  '[CitizensGroupSummaries/API] Citizen Get Group Summaries'
);
